module.exports = __webpack_public_path__ + "img/organize-role.5cd5f977.svg";